// Capture closed shadow roots from shopify-accelerated-checkout-cart
const __capturedShadowRoots = new WeakMap();
const __origAttachShadow = Element.prototype.attachShadow;
Element.prototype.attachShadow = function (init) {
  const sr = __origAttachShadow.call(this, init);
  if (this.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') {
    __capturedShadowRoots.set(this, sr);
  }
  return sr;
};

const hideIrrelevantWalletButtons = () => {
  const ua = navigator.userAgent;
  const isApple = /Mac|iPhone|iPad|iPod/i.test(ua);
  const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  console.log('[hideWallet] init | isApple:', isApple, '| isSafari:', isSafari, '| isAndroid:', isAndroid);

  if (!isApple && !isAndroid) {
    console.log('[hideWallet] Not Apple or Android, exiting');
    return;
  }

  /** @param {Element} el */
  const hideEl = (el) => {
    if (!el) return;

    const tagName = el.tagName?.toLowerCase() || 'unknown';
    const slotAttr = el.getAttribute?.('slot') || 'none';
    console.log('[hideWallet] hideEl called on:', tagName, '| slot:', slotAttr);

    // Safety: ONLY process the exact button types we intend to hide
    const allowedTags = ['shopify-google-pay-button', 'shopify-apple-pay-button'];
    if (!allowedTags.includes(tagName)) {
      console.log('[hideWallet]   BLOCKED: tag', tagName, 'is not in allowed list, skipping');
      return;
    }

    // Skip if we've already processed this exact element
    if (el.dataset?.walletHidden === 'true') {
      console.log('[hideWallet]   already hidden, skipping');
      return;
    }

    // 1. Hide the element itself
    if (el.style) {
      el.style.setProperty('display', 'none', 'important');
      console.log('[hideWallet]   step 1: set display:none on', tagName);
    }
    el.dataset.walletHidden = 'true';

    // 2. Hide inside its own shadow DOM if accessible (open shadow roots only)
    if (el.shadowRoot && !el.dataset.shadowHidden) {
      const style = document.createElement('style');
      style.textContent = ':host { display: none !important; height: 0 !important; } * { display: none !important; }';
      el.shadowRoot.appendChild(style);
      el.dataset.shadowHidden = 'true';
      console.log('[hideWallet]   step 2: injected style into', tagName, 'shadow DOM');
    }

    // 3. PIERCE THE CLOSED SHADOW DOM of the cart container to hide the slot's wrapper
    const cartContainer = el.closest('shopify-accelerated-checkout-cart');
    const sr = cartContainer && __capturedShadowRoots.get(cartContainer);
    console.log('[hideWallet]   step 3: cartContainer =', !!cartContainer, '| capturedSR =', !!sr);

    if (sr) {
      const slotName = el.getAttribute('slot');
      console.log('[hideWallet]   looking for slot:', slotName);

      if (slotName) {
        const containers = sr.querySelectorAll('.wallet-cart-button-container');
        console.log('[hideWallet]   found', containers.length, 'containers in shadow root');

        for (let i = 0; i < containers.length; i++) {
          const container = containers[i];
          const slotEl = container.querySelector('slot');
          const slotElName = slotEl?.getAttribute('name');
          console.log(`[hideWallet]     container[${i}] slot: "${slotElName}" | target: "${slotName}" | match: ${slotElName === slotName}`);

          if (slotElName === slotName) {
            container.style.setProperty('display', 'none', 'important');
            container.style.setProperty('height', '0', 'important');
            container.style.setProperty('margin', '0', 'important');
            container.style.setProperty('padding', '0', 'important');
            container.style.setProperty('min-height', '0', 'important');
            console.log(`[hideWallet]     >>> HIDDEN container[${i}] for slot "${slotName}"`);
            break;
          }
        }
      }
    }

    // NOTE: No parent-walking step. All wallet buttons are siblings under
    // <shopify-accelerated-checkout-cart>, so walking up from one button
    // hits shared parents and risks hiding PayPal or Shop Pay.
    // Step 3 handles the gap by hiding the slot container inside the shadow DOM.
  };

  const applyHiding = () => {
    if (isAndroid) {
      const btns = document.querySelectorAll('shopify-apple-pay-button');
      if (btns.length) console.log('[hideWallet] applyHiding: Apple Pay buttons found:', btns.length);
      btns.forEach(hideEl);
    }
    if (isApple && isSafari) {
      const btns = document.querySelectorAll('shopify-google-pay-button');
      if (btns.length) console.log('[hideWallet] applyHiding: Google Pay buttons found:', btns.length);
      btns.forEach(hideEl);
    }
  };

  applyHiding();

  const observer = new MutationObserver(applyHiding);
  observer.observe(document.body, { childList: true, subtree: true });
};

hideIrrelevantWalletButtons();
